import { GetBankInfo, List } from "@/types/Api/User/PaymentType/getBankInfo";
import { create } from "zustand";

type BankMap = Record<List["bankId"], List["bankName"]>;
interface BankStore {
  banks: GetBankInfo["response"]["list"];
  bankMap: BankMap;
  setBanks: (banks: GetBankInfo["response"]["list"]) => void;
}

export const useBankStore = create<BankStore>((set) => ({
  banks: [],
  bankMap: {},
  setBanks: (banks) => {
    const bankMap: BankMap = banks.reduce((prev: BankMap, cur) => {
      prev[cur.bankId] = cur.bankName;
      return prev;
    }, {});
    return set(() => ({ banks, bankMap }));
  },
}));
